<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Notification</h4>
        <!-- <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button> -->
    </div>
    <div class="modal-body">
        <p style="text-align: center; padding: 20px 0; color: #3f3f3f;">{{notif}}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Close</button>
    </div>
</ng-template>


<div class="registration-wrapper">
  <div class="header">
    <h1 style="color: rgb(55, 55, 55);">PODCAs MEMBERSHIP REGISTRATION FORM</h1>
    <p style="color: rgb(84, 84, 84);">
      <strong>PODCAs</strong> is committed to fostering the growth and success of online sellers,
      distributors, and e-commerce entrepreneurs by providing a platform for advocacy,
      professional development, and industry collaboration. Our organization strives to create a
      supportive environment that empowers members with access to valuable resources,
      networking opportunities, and policy representation.
    </p>
    <button class="fee-button">Application (One Time Fee: ₱1,500)</button>
  </div>

  <div class="form-box">
    <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <input type="text" placeholder="Last name, First name, Middle name" formControlName="fullName" />
        <input type="text" placeholder="Contact Number" formControlName="contact" />
      </div>
      <input type="email" placeholder="Email Address" formControlName="email" />
      <input type="text" placeholder="House No./Street/Subdivision/Village" formControlName="address" />

      <div class="row">
        <input type="text" placeholder="Barangay" formControlName="barangay" />
        <input type="text" placeholder="City" formControlName="city" />
      </div>
      <div class="row">
        <input type="text" placeholder="Province" formControlName="province" />
        <input type="text" placeholder="Country" formControlName="country" />
      </div>

      <input type="text" placeholder="Agency / Organization / Company" formControlName="agency" />

      <div class="row">
        <input type="text" placeholder="Describe your Products*" formControlName="productDescription" />
        <input type="text" placeholder="Designation*" formControlName="designation" />
      </div>

      <hr />
      <h4 class="section-title">WHICH CATEGORY DO YOU BELONG?</h4>

      <div class="category-list">
        <label class="category-item" *ngFor="let cat of categories">
          <input type="checkbox" [value]="cat.value" (change)="onCategoryChange(cat.value, $event.target.checked)" />
          <div>
            <strong>{{ cat.label }}</strong>
            <p *ngIf="!cat.waived">{{ cat.description }}</p>
            <span class="fee-badge" [class.waived]="cat.waived">Fee: {{ cat.fee }}</span>
          </div>
        </label>
      </div>

      <!-- Trustee Section -->
      <div class="info-box">
        <h4 class="info-title">TRUSTEE ACCOUNT FOR DEPOSIT</h4>
        <p style="color: rgb(84, 84, 84);"><strong>Account Name:</strong> Mylene Ondoy</p>
        <p style="color: rgb(84, 84, 84);"><strong>Checking Account No.:</strong> 3171037602</p>
        <p style="color: rgb(84, 84, 84);"><strong>Bank:</strong> Bank of the Philippine Islands (BPI)</p>

        <h4 class="info-title">PROOF OF DEPOSIT SUBMISSION</h4>
        <p style="color: rgb(84, 84, 84);">
          Once the deposit has been made, kindly send the proof of deposit for
          validation via one of the following channels:
        </p>
        <br />
        <p style="color: rgb(84, 84, 84);"><strong>Email:</strong> podcas.secretariat@gmail.com</p>
        <p style="color: rgb(84, 84, 84);"><strong>Viber:</strong> 09202968440</p>

        <p class="note">
          Note: Kindly send the application fee within 3 days to complete your registration.
          Please note that your application may be considered void if the fee is not received within the given timeframe.
          Email the Proof of Payment at <strong>podcas.secretariat@gmail.com</strong>.
        </p>
      </div>

      <!-- Assistant Info -->
      <div class="assistant-box">
        <h4>FOR SECRETARIAT PURPOSES, JUST IN CASE WE CAN’T REACH YOU</h4>
        <div class="row">
          <input type="text" placeholder="Name of Assistant*" formControlName="assistantName" />
          <input type="text" placeholder="Assistant’s Contact No.*" formControlName="assistantContact" />
        </div>
        <input type="email" placeholder="Assistant’s Email Address*" formControlName="assistantEmail" />
      </div>

      <!-- Consent and Submit -->
      <div class="consent-box">
        <label class="consent">
          <input type="checkbox" formControlName="consent" />
          I hereby consent to the collection and processing by the PODCAs of my name, contact details, and my
          feedback on its services for the purpose of monitoring, measuring, and analyzing members feedback
          and of improving PODCAs services. I shall notify the PODCAs in case of any changes in my personal
          information. This consent shall be valid, unless revoked or withdrawn in writing subject to the
          applicable provisions of the <strong>Data Privacy Act of 2012</strong> or Republic Act No. 10173.
        </label>

        <button type="submit" class="submit-btn" [disabled]="registrationForm.invalid">SUBMIT</button>
      </div>
    </form>
  </div>
</div>
